export default __webpack_public_path__ + "static/media/whea.7bbbab2d.svg";